import {
  v2PwaBasePath,
  projectBasePathWithFolder,
  imgBaseUrl,
  shouldHideCompleteLocationFlow,
  homeMenuCategory,
  homeGuestMenuCategory,
  keyForEncryDecry,
  paymentsProjectBasePathWithFolder,
  corporateOrderQtyLimit,
  isCorporateSite,
  envConfig,
} from "../config/apiEndpoints";
import store from "../store/index";
import LocalStorageFunc from "./localStorageFunc";
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import PageNames from "../config/pageNames";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS_CATEGORY,
} from "../config/vwoKeys";
import { MINIAPP, ORDER_TYPE } from "./paymentConstants";
import gpayUtility from "./gpayUtility";
import paytmMicroapp from "./paytmMicroapp";
import Location from "../config/location.js";
import CryptoJs from "crypto-js";
import setEvents from "./events.js";

const randomnumber = (minimum = 100000000, maximum = 999999999) => {
  return Math.floor(Math.random() * (maximum - minimum, maximum + 1)) + minimum;
};

const pizzaCounter = () => {
  if (!!window.IntersectionObserver) {
    let observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            store.commit(
              keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
              entry.target.id,
            );
          }
        });
      },
      {
        root: null,
        threshold: pizzaCounterThreshold(), //0.1 for anchor links
        rootMargin: pizzaCounterRootMargin(),
      },
    );
    store.commit(keyMapsMutation.SET_PRODUCT_OBSERVER, observer);
  }
};

const pizzaCounterRootMargin = () => {
  if (isSeparateMenuVariant()) {
    return "-150px 0% 0% 0%";
  }
  return "-10% 0% -80% 0%";
};

const pizzaCounterThreshold = () => {
  if (isSeparateMenuVariant()) return 0;
  else return 0.1;
};

const tryJsonParse = (value, defaultValue = {}) => {
  let _;
  if (value === null || value === "null") return defaultValue;
  try {
    _ = JSON.parse(value);
  } catch (e) {
    return defaultValue;
  }
  return _;
};

const checkNextgenVariant = (currentExperimentValue) => {
  return true;
  return (
    currentExperimentValue?.startsWith("nextgen_variant_") || isNoRedirectTrue()
  );
};

const calculateIsTrueLocationDetectedFromLocationSource = () => {
  return LocalStorageFunc.getLocationSource() == "ip" ? false : true;
};

const checkIfOrderTypeNonDelivery = (deliveryType) =>
  !!(
    deliveryType === "P" ||
    deliveryType === "DINEIN" ||
    deliveryType === "CURB"
  );

const takeawayDineinFolder = (isTrueLocationDetected) => {
  if (isTrueLocationDetected) {
    return `${window?._siteProps_?.props?.postorderUIBasepath}nearestStore`;
  }
  const takeawayLocation = getSessionStorageValue("takeawayLocation");
  if (typeof takeawayLocation != "undefined" && takeawayLocation)
    return `${window?._siteProps_?.props?.postorderUIBasepath}nearestStore`;
  return `${window?._siteProps_?.props?.postorderUIBasepath}searchAddress`;
};

const redirectUrlForNonDeliveryOrderType = (
  isTrueLocationDetected,
  deliveryType,
) => {
  const takeAwayCoords = LocalStorageFunc.getCoordsForTakeaway();
  if (!isTrueLocationDetected && takeAwayCoords) {
    const { latitude, longitude } = takeAwayCoords?.coords || {};
    return `${window?._siteProps_?.props?.postorderUIBasepath}nearestStore?deliveryType=${deliveryType}&latitude=${latitude}&longitude=${longitude}`;
  }
  let redirectUrl = takeawayDineinFolder(isTrueLocationDetected);
  return `${redirectUrl}?deliveryType=${deliveryType}`;
};

const deliveryFolder = (isLoggedIn) => {
  if (isLoggedIn) {
    let userAddresses = localStorage.userAddresses
      ? tryJsonParse(localStorage.userAddresses)
      : "";
    if (Array.isArray(userAddresses) && userAddresses.length > 0)
      return "address";
  }
  return "changeAddress";
};

const textLowerAndTrimSpace = (text) =>
  text.toLocaleLowerCase().replace(/\s/g, "");

const getPwaV2CurrentCustomisation = (
  productId,
  currentCustomisation,
  toppingsData,
) => {
  let extraKeys = {};

  let extraCheeseToppings = {
    price: { 6: "50.00", 7: "75.00", 8: "95.00" },
    toppingId: 51,
    description: "",
    name: "Extra Cheese",
    images: "extraCheese.jpg",
    type: 2,
    custAttrField: "C.",
  };

  if (currentCustomisation[productId]?.addTopngs) {
    extraKeys["addTopngs"] = currentCustomisation[productId].addTopngs.map(
      (__) => {
        let result = {};
        for (var i = 0; i < toppingsData.length; i++) {
          if (+toppingsData[i].toppingId === +__) {
            result = toppingsData[i];
            break;
          } else if (extraCheeseToppings.toppingId === +__) {
            result = extraCheeseToppings;
            break;
          }
        }
        return result;
      },
    );
  }

  if (currentCustomisation[productId]?.remTopngs) {
    extraKeys["remTopngs"] = currentCustomisation[productId].remTopngs.map(
      (__) => {
        let result = {};
        for (var i = 0; i < toppingsData.length; i++) {
          if (+toppingsData[i].toppingId === +__) {
            result = toppingsData[i];
            break;
          } else if (extraCheeseToppings.toppingId === +__) {
            result = extraCheeseToppings;
            break;
          }
        }
        return result;
      },
    );
  }
  if (currentCustomisation[productId]?.repTopngs) {
    extraKeys["repTopngs"] = currentCustomisation[productId].repTopngs.map(
      (__) => {
        let result = {};
        for (var i = 0; i < toppingsData.length; i++) {
          if (+toppingsData[i].toppingId === +__) {
            result = toppingsData[i];
            break;
          } else if (extraCheeseToppings.toppingId === +__) {
            result = extraCheeseToppings;
            break;
          }
        }
        return result;
      },
    );
  }
  return {
    ...currentCustomisation[productId],
    ...extraKeys,
  };
};

const getProductHashcode = (code, id) => {
  // return (code || "") + (id || "");
  return code || "";
};

const keybasedProductItem = (_) => {
  let response = {};
  let priceHashCode = {};
  _?.forEach((__) => {
    let temp2 = {};
    __.data?.forEach((___) => {
      const hashCode = getProductHashcode(___.code, ___.id);
      temp2[hashCode] = ___;
      priceHashCode[hashCode] = {};
      temp2[hashCode]["customCategoryId"] = __.categoryId;
      temp2[hashCode]["customCategoryName"] = __.categoryName;

      temp2[hashCode].crust?.map((c) => {
        priceHashCode[hashCode][c.crustId] = {};
        c?.sizes?.map((s) => {
          priceHashCode[hashCode][c.crustId][s.sizeId] = s.price;
        });
      });

      if (isEdvPage() || !temp2[hashCode]["defaultPrice"]) {
        let forcedSlectedSizeIdFlag = false;
        temp2[hashCode]["defaultPrice"] = +temp2[hashCode].crust
          ?.filter((_) => {
            if (_.crustId == temp2[hashCode].selectedCrustId) {
              temp2[hashCode]["defaultCrustName"] = _.name;
              temp2[hashCode]["crustName"] = _.name;
              temp2[hashCode]["crustId"] = temp2[hashCode].selectedCrustId;

              const selectedSizeArray = _.sizes.find((i) => {
                if (i.sizeId == "6") {
                  forcedSlectedSizeIdFlag = i.sizeId;
                  return true;
                }
              });
            }
            return _.crustId == temp2[hashCode].selectedCrustId;
          })[0]
          ?.sizes?.filter((_) => {
            if (forcedSlectedSizeIdFlag) {
              temp2[hashCode].selectedSizeId = forcedSlectedSizeIdFlag;
            }
            if (_.sizeId == temp2[hashCode].selectedSizeId) {
              temp2[hashCode]["defaultSizeName"] = _.name;
              temp2[hashCode]["sizeName"] = _.name;
              temp2[hashCode]["sizeId"] = temp2[hashCode].selectedSizeId;
            }
            return _.sizeId == temp2[hashCode].selectedSizeId;
          })[0]?.price;
        temp2[hashCode]["itemPrice"] = temp2[hashCode]["defaultPrice"];
      }
      temp2[hashCode]["itemPrice"] = temp2[hashCode]["defaultPrice"];
      temp2[hashCode]["addTopngs"] = [];
      temp2[hashCode]["product"] = {
        id: temp2[hashCode]["id"],
        code: temp2[hashCode]["code"],
      };

      if (Object.keys(priceHashCode[hashCode]) == 0) {
        delete priceHashCode[hashCode];
      }
    });
    response[__.categoryName] = { ...__, data: temp2 };
  });

  return { response: response, priceHashCode: priceHashCode };
};

const addMissingKeyAccToLoadDataAndProductItems = (__) => {
  let response = [];
  let temp2 = {};
  let priceHashCode = {};

  __?.forEach((___) => {
    temp2[___.code] = ___;
    priceHashCode[___.code] = {};
    temp2[___.code].crust?.map((c) => {
      priceHashCode[___.code][c.crustId] = {};
      c?.sizes?.map((s) => {
        priceHashCode[___.code][c.crustId][s.sizeId] = s.price;
      });
    });

    if (!temp2[___.code]["defaultPrice"]) {
      let forcedSlectedSizeIdFlag = false;
      temp2[___.code]["defaultPrice"] = +temp2[___.code].crust
        .filter((_) => {
          if (_.crustId == temp2[___.code].selectedCrustId) {
            temp2[___.code]["defaultCrustName"] = _.name;

            const selectedSizeArray = _.sizes.find((i) => {
              if (i.sizeId == "6") {
                forcedSlectedSizeIdFlag = i.sizeId;
                return true;
              }
            });
          }
          if (_.crustId == temp2[___.code].orderedCrustId) {
            //temp2[___.code]["defaultCrustName"] = _.name;
            temp2[___.code]["crustName"] = _.name;
            temp2[___.code]["crustId"] = temp2[___.code].orderedCrustId;
          }
          return _.crustId == temp2[___.code].orderedCrustId;
        })[0]
        ?.sizes.filter((_) => {
          if (forcedSlectedSizeIdFlag) {
            temp2[___.code].selectedSizeId = forcedSlectedSizeIdFlag;
          }

          if (_.sizeId == temp2[___.code].selectedSizeId) {
            temp2[___.code]["defaultSizeName"] = _.name;
          }
          if (_.sizeId == temp2[___.code].orderedSizeId) {
            //temp2[___.code]["defaultSizeName"] = _.name;
            temp2[___.code]["sizeName"] = _.name;
            temp2[___.code]["sizeId"] = temp2[___.code].orderedSizeId;
          }
          return _.sizeId == temp2[___.code].orderedSizeId;
        })[0]?.price;
      temp2[___.code]["itemPrice"] = temp2[___.code]["defaultPrice"];
    }
    temp2[___.code]["itemPrice"] = temp2[___.code]["defaultPrice"];
    temp2[___.code]["product"] = {
      id: temp2[___.code]["id"],
      code: temp2[___.code]["code"],
    };

    if (Object.keys(priceHashCode[___.code]) == 0) {
      delete priceHashCode[___.code];
    }
    temp2[___.code]["addTopngs"] = temp2[___.code]["orderedAddToppings"] || [];
    temp2[___.code]["remTopngs"] =
      temp2[___.code]["orderedRemoveToppings"] || [];
    temp2[___.code]["repTopngs"] =
      temp2[___.code]["orderedReplaceToppings"] || []; //because of keys name change - and we use old keys

    response.push(temp2[___.code]);
  });
  return response;
};
const getCategoryIdBasedMenuCodesFromSequencing = function (data) {
  var _ = {};
  data?.map((__) => {
    if (__.categoryId) {
      _[+__.categoryId] = __.menuCodes;
    }
  });
  return _;
};

const sequencedProductItems = function (items, sequence) {
  var _ = [];
  items?.map((__) => {
    _.push({
      ...__,
      data: __.data?.sort((itemA, itemB) => {
        var itemAindex = sequence.indexOf(itemA.code);
        if (itemAindex == -1) {
          itemAindex = 200;
        }
        var itemBindex = sequence.indexOf(itemB.code);
        if (itemBindex == -1) {
          itemBindex = 300;
        }
        return itemAindex - itemBindex;
      }),
    });
  });
  return _;
};

const getCurrentToppingsTotalPrice = (toppingsMasterData, item) => {
  let sum = 0;
  item.addTopngs?.map((_) => {
    sum =
      sum +
        +toppingsMasterData.filter((__) => {
          return __.toppingId == _;
        })[0]?.price[item.sizeId] || 0;
  });
  return sum;
};

const redirectToLoginScreen = () => {
  // localStorage.finalRedirectUrl = location.href;

  const loginPageUrl = `/${window?._siteProps_?.props?.postorderUIBasepath}login`;
  window.location.href =
    v2PwaBasePath + loginPageUrl + "?redirectUrl=" + location.href;
};

const redirectToTncScreen = () => {
  const tncScreen = `/${window?._siteProps_?.props?.postorderUIBasepath}tnc`;
  window.location.href =
    v2PwaBasePath +
    tncScreen +
    "?redirectUrl=" +
    location.href +
    "&handleTnc=true";
};

const getEdvPageUrl = (type) => {
  let edvPageURL =
    projectBasePathWithFolder +
    `/${PageNames.NEXTGEN_LINKREWRITE_EDV}/` +
    LocalStorageFunc.storeId();
  if (type) {
    edvPageURL = edvPageURL + `?type=${type}`;
  }
  return edvPageURL;
};

const sendToLoginScreen = (location) => {
  const isMiniApp = getMiniAppStorageVal();
  if (isMiniApp === MINIAPP.GPAY) {
    gpayUtility.getGpayUserPhoneNumber(location);
  } else if (isMiniApp === MINIAPP.PAYTM) {
    paytmMicroapp.getUserDetails(location);
  } else {
    redirectToLoginScreen();
  }
  return;
};

const sendToLoyaltyScreen = () => {
  let url =
    projectBasePathWithFolder +
    `/${PageNames.NEXTGEN_LINKREWRITE_LOYALTY}/` +
    LocalStorageFunc.storeId() +
    getUrlQueryString();
  window.location.href = url;
  return;
};

const sendToNxgWalletScreen = (page = "wallet") => {
  let queryParams = getQueryFromUrl();
  if (queryParams["platform"]) {
    let url =
      projectBasePathWithFolder +
      `/${PageNames.NEXTGEN_LINKREWRITE_NXG_WALLET}?page=${page}` +
      "&platform=" +
      queryParams["platform"] +
      "&redirectUrl=" +
      encodeURIComponent(location.href);
    window.location.href = url;
  } else {
    let url =
      projectBasePathWithFolder +
      `/${PageNames.NEXTGEN_LINKREWRITE_NXG_WALLET}?page=${page}` +
      "&redirectUrl=" +
      encodeURIComponent(location.href);
    window.location.href = url;
  }
  return;
};

const sendToMenuScreen = (category = "") => {
  let url =
    projectBasePathWithFolder +
    getMenuCategory() +
    LocalStorageFunc.storeId() +
    getUrlQueryString();
  window.location.href = url;
  return;
};

const getAppDownloadLink = () => {
  return "https://dominos.onelink.me/uM7R/3e839899";
};

const getNoRedirectFromWindow = () => {
  const noRedirect = window?.noredirect;
  if (noRedirect === false) {
    return noRedirect;
  }
  return true;
};

const getCurrentStoreFolder = () => {
  let linkRewrite = getLinkRewriteFromSiteprops();

  // returns menuCategory
  if (linkRewrite === PageNames.NEXTGEN_LINKREWRITE_MENUV1) {
    return `/${PageNames.NEXTGEN_LINKREWRITE_MENUV1}/`;
  }
  if (linkRewrite === PageNames.NEXTGEN_LINKREWRITE_MENUV2) {
    return `/${PageNames.NEXTGEN_LINKREWRITE_MENUV2}/`;
  }
  if (linkRewrite === PageNames.NEXTGEN_LINKREWRITE_DELETE_ACCOUNT) {
    return `/${PageNames.NEXTGEN_LINKREWRITE_DELETE_ACCOUNT}/`;
  }
  if (linkRewrite === PageNames.NEXTGEN_LINKREWRITE_EDV) {
    return `/${PageNames.NEXTGEN_LINKREWRITE_EDV}/`;
  }
  if (linkRewrite === PageNames.NEXTGEN_LINKREWRITE_RELAY) {
    return `/${PageNames.NEXTGEN_LINKREWRITE_RELAY}/`;
  }
  if (linkRewrite === PageNames.NEXTGEN_LINKREWRITE_LOYALTY) {
    return `/${PageNames.NEXTGEN_LINKREWRITE_LOYALTY}/`;
  }

  // returns homepageCategory
  if (checkIfDefaultStoreId() && !LocalStorageFunc.isLoggedIn()) {
    return `/${PageNames.NEXTGEN_LINKREWRITE_HOME_GUEST || linkRewrite}/`;
  }
  return `/${PageNames.NEXTGEN_LINKREWRITE_HOME || linkRewrite}/`;
};

const onlyShowCategory = (elementId) => {
  let elements = document.querySelectorAll('*[id^="category_items_id_"]');
  elements.forEach((ele) => {
    if (ele.id === elementId) {
      ele.style.display = "";
    } else {
      ele.style.display = "none";
    }
  });
};

const scrollPageTo = (elmId, topValMargin = 70, behavior = "smooth") => {
  let el = document.getElementById(elmId);
  if (el !== null) {
    let top = el.offsetTop;
    function listener() {
      if (top - topValMargin - window.scrollY <= 300) {
        const newOffset = el.offsetTop;
        if (top !== newOffset) {
          window.scrollTo({
            top: newOffset - topValMargin,
            left: 100,
            behavior: "instant",
          });
        }
        window.removeEventListener("scroll", listener);
      }
    }
    window.addEventListener("scroll", listener);
    window.scrollTo({
      top: top - topValMargin,
      left: 100,
      behavior: behavior,
    });
  }
};

const scrollUptoTo = (elmId, topValMargin = 70) => {
  if (isSeparateMenuVariant() || isEdvPage()) {
    if (elmId.includes("element_catg_")) {
      let elementId = elmId.replace("element_catg_", "category_items_id_");
      onlyShowCategory(elementId);
      scrollUptoTo("pageTop");
    } else if (elmId === "pageTop") {
      scrollPageTo(elmId, 158, "instant");
    }
  } else {
    scrollPageTo(elmId, topValMargin);
  }
};

const scrollUptoMenuTop = (topVal = 70) => {
  const menuArray = document.querySelectorAll('*[id^="element_catg_"]');
  if (menuArray.length > 0) {
    if (isSeparateMenuVariant()) {
      let elementId = menuArray[0].id.replace(
        "element_catg_",
        "category_items_id_",
      );
      onlyShowCategory(elementId);
      scrollUptoTo("pageTop");
    } else {
      let top = menuArray[0].offsetTop;
      window.scrollTo({
        top: top - topVal, //70
        left: 100,
        behavior: "smooth",
      });
    }
  }
};

const isSeparateMenuVariant = () => {
  if (
    [
      PageNames.NEXTGEN_LINKREWRITE_MENUV1,
      PageNames.NEXTGEN_LINKREWRITE_MENUV2,
    ].includes(getLinkRewriteFromSiteprops())
  ) {
    return true;
  }
  return false;
};
const isEdvPage = () => {
  if (
    [PageNames.NEXTGEN_LINKREWRITE_EDV].includes(getLinkRewriteFromSiteprops())
  ) {
    return true;
  }
  return false;
};

const isLoyaltyPage = () => {
  if (
    [PageNames.NEXTGEN_LINKREWRITE_LOYALTY].includes(
      getLinkRewriteFromSiteprops(),
    )
  ) {
    return true;
  }
  return false;
};

const isMenuPage = () => {
  if (
    [
      PageNames.NEXTGEN_LINKREWRITE_MENUV1,
      PageNames.NEXTGEN_LINKREWRITE_MENUV2,
      PageNames.NEXTGEN_LINKREWRITE_MENU,
    ].includes(getLinkRewriteFromSiteprops())
  ) {
    return true;
  }
  return false;
};

const getToppingPriceForSize = (toppingsArray, toppingId, sizeId) => {
  let _ = 0;
  for (let i = 0; i < toppingsArray.length; i++) {
    if (toppingsArray[i].toppingId == toppingId) {
      _ = +toppingsArray[i].price[sizeId];
      break;
    }
  }
  return _;
};

const toppingsNameByToppingId = (mainArry, allTopngs, data) => {
  let currentToppingsName = [];
  if (mainArry?.length > 0 && data?.length > 0) {
    currentToppingsName = mainArry.filter((i) => {
      if (data.sort().toString() == i.addTopngs.sort().toString()) {
        return i;
      }
    });
  }
  let obj = currentToppingsName[0] || [];
  if (obj.addTopngs) {
    let newObj = obj.addTopngs.map((i) => Number(i));
    return allTopngs
      .filter((j) => newObj.includes(Number(j.toppingId)))
      .map((o) => o.name)
      .join();
  } else {
    return "";
  }
};

const currentCrustName = (arry, result) => {
  // arry = it is current CartItems from store
  // result = it is current selected item which will going to add or sub
  let ary = [];
  if (arry && result) {
    ary = arry.filter((i) => i.crustName == result.crustName);
  }
  return ary[0]?.crustName || "";
};

const currentSizeName = (arry, result) => {
  // arry = it is current CartItems from store
  // result = it is current selected item which will going to add or sub
  let name = [];
  if (arry && result) {
    name = arry.filter((i) => i.sizeName == result.sizeName);
  }
  return name[0]?.sizeName || "";
};

const deepCopyArry = (data) => {
  return JSON.parse(JSON.stringify(data));
};
const sortQniqueArry = (data) => {
  return Array.from(new Set(data.map(JSON.stringify))).map(JSON.parse);
};

const getWidgetWidthHeight = (
  itemsInScreen = 1.75,
  aspectRatio = 1,
  gap = 28,
  minWidth = 300,
) => {
  let width = (window.innerWidth - gap) / itemsInScreen;
  let height = width / (aspectRatio + gap);
  return {
    width: width >= minWidth ? width : minWidth,
    height: height,
  };
};

const amplitudeEventObj = (
  userAction,
  sectionName,
  sectionPosition,
  preObj,
) => {
  return {
    userAction,
    sectionName,
    sectionPosition,
    ...(preObj.positionWithinSection && {
      positionWithinSection: preObj.positionWithinSection,
    }),
    ...(preObj.category && { category: preObj.category }),
    ...(preObj.subCategory && { subCategory: preObj.subCategory }),
    ...(preObj.orderType && { orderType: preObj.orderType }),
    ...(preObj.searchSection && { searchSection: preObj.searchSection }),
    ...(preObj.searchQuery && { searchQuery: preObj.searchQuery }),
    ...(preObj.entryFrom && { entryFrom: preObj.entryFrom }),
    ...(preObj.categoryPosition && {
      categoryPosition: preObj.categoryPosition,
    }),
    ...(preObj.offerType && { offerType: preObj.offerType }),
    ...(preObj.milestoneStage && { milestoneStage: preObj.milestoneStage }),
    ...(preObj.offerStage && { offerStage: preObj.offerStage }),
    ...(preObj.impressionType && { impressionType: preObj.impressionType }),
    ...(preObj.scrollType && { scrollType: preObj.scrollType }),
    ...(preObj?.eventType === "RewardPointsImpression"
      ? {
          enrollmentStatus: preObj.enrollmentStatus,
        }
      : preObj.enrollmentStatus && {
          enrollmentStatus: preObj.enrollmentStatus,
        }),
    ...(preObj?.eventType === "RewardPointsImpression"
      ? { points: preObj.points }
      : preObj.points && { points: preObj.points }),
    ...(preObj.loginStatus && { loginStatus: preObj.loginStatus }),
    ...(preObj.actionType && { actionType: preObj.actionType }),
    ...(preObj.addToCart && { addToCart: preObj.addToCart }),
    ...(preObj.sellerType && { sellerType: preObj.sellerType }),
    ...(preObj.popularityType && { popularityType: preObj.popularityType }),
    ...(preObj.addCounter && { addCounter: preObj.addCounter }),
    ...(preObj.price && { price: preObj.price }),
    ...(preObj.size && { size: preObj.size }),
    ...(preObj.crust && { crust: preObj.crust }),
    ...(preObj.isIrctcOrder && { isIrctcOrder: preObj.isIrctcOrder }),
    ...(preObj.upsell && { upsell: preObj.upsell }),
    ...(preObj.upsellStatus && { upsellStatus: preObj.upsellStatus }),
    ...(preObj.eventCategory && { eventCategory: preObj.eventCategory }),
    ...(preObj.eventAction && { eventAction: preObj.eventAction }),
    ...(preObj.itemName && { itemName: preObj.itemName }),
    ...(preObj.itemSku && { itemSku: preObj.itemSku }),
    ...(preObj.ecomCategory && { ecomCategory: preObj.ecomCategory }),
    ...(preObj.addToCartQuantity && {
      addToCartQuantity: preObj.addToCartQuantity,
    }),
    ...(preObj.customisationType && {
      customisationType: preObj.customisationType,
    }),
    ...(preObj.isCustomisable && { isCustomisable: preObj.isCustomisable }),
    ...(preObj.updateType && { updateType: preObj.updateType }),
    ...(preObj.addNonVegToppings && {
      addNonVegToppings: preObj.addNonVegToppings,
    }),
    ...(preObj.addVegToppings && { addVegToppings: preObj.addVegToppings }),
    ...(preObj.changeCrust && { changeCrust: preObj.changeCrust }),
    ...(preObj.changeSize && { changeSize: preObj.changeSize }),
    ...(preObj.close && { close: preObj.close }),
    ...(preObj.entry && { entry: preObj.entry }),
    ...(preObj.replaceToppings && { replaceToppings: preObj.replaceToppings }),
    ...(preObj.add && { add: preObj.add }),
    ...(preObj.resetAll && { resetAll: preObj.resetAll }),
    ...(preObj.update && { update: preObj.update }),
    ...(preObj.resultCount && { resultCount: preObj.resultCount }),
    ...(preObj.topResult && { topResult: preObj.topResult }),
    ...(preObj.locationStatus && { locationStatus: preObj.locationStatus }),
    screenName: preObj.screenName
      ? preObj.screenName
      : PageNames.NEXTGEN_HOMEPAGE,
    Page_Name: preObj.screenName
      ? preObj.screenName
      : PageNames.NEXTGEN_HOMEPAGE,
    previousScreenname: preObj.previousScreenname
      ? preObj.previousScreenname
      : preObj.screenName && preObj.screenName !== PageNames.NEXTGEN_HOMEPAGE
        ? PageNames.NEXTGEN_HOMEPAGE
        : document.referrer,
    Previous_page: preObj.previousScreenname
      ? preObj.previousScreenname
      : preObj.screenName && preObj.screenName !== PageNames.NEXTGEN_HOMEPAGE
        ? PageNames.NEXTGEN_HOMEPAGE
        : document.referrer,
    ...(preObj["Previous Page_Name"] && {
      ["Previous Page_Name"]: preObj.previousScreenname
        ? preObj.previousScreenname
        : preObj.screenName && preObj.screenName !== PageNames.NEXTGEN_HOMEPAGE
          ? PageNames.NEXTGEN_HOMEPAGE
          : document.referrer,
    }),
    ...(preObj.subSection && { subSection: preObj.subSection }),
    ...(preObj.menuCategories?.length > 0 && {
      menuCategories: preObj.menuCategories,
    }),
    ...(preObj.menuCount && { menuCount: preObj.menuCount }),
    ...(preObj.rating_type && { rating_type: preObj.rating_type }),
    ...(preObj.rating && { rating: preObj.rating }),
    ...(preObj.errorType && { errorType: preObj.errorType }),
    ...(preObj.Event_Label && { Event_Label: preObj.Event_Label }),
    ...(preObj.Event_Category && { Event_Category: preObj.Event_Category }),
    ...(preObj.Event_Action && { Event_Action: preObj.Event_Action }),
    ...(preObj.rewardsProgramme && {
      rewardsProgramme: preObj.rewardsProgramme,
    }),
    ...(preObj.aggregatorFlow && { aggregatorFlow: preObj.aggregatorFlow }),
    ...(preObj.POTP_Programme_Type && {
      POTP_Programme_Type: preObj.POTP_Programme_Type,
    }),
    ...(preObj.mealOriginalPrice && {
      mealOriginalPrice: preObj.mealOriginalPrice,
    }),
    ...(preObj.mealFinalPrice && { mealFinalPrice: preObj.mealFinalPrice }),
    ...(preObj.mealSavings && { mealSavings: preObj.mealSavings }),
    ...(preObj.nghDeliveryTime && { nghDeliveryTime: preObj.nghDeliveryTime }),
    ...(preObj.dineinDistance && { dineinDistance: preObj.dineinDistance }),
    ...(preObj.takeawayDistance && {
      takeawayDistance: preObj.takeawayDistance,
    }),
    ...(preObj.deliveryDuration && {
      deliveryDuration: preObj.deliveryDuration,
    }),
    ...(preObj.locationType && { locationType: preObj.locationType }),
    ...(preObj.storeID && { storeID: preObj.storeID }),
    ...(preObj.eventLabel && { eventLabel: preObj.eventLabel }),
    ...(preObj.hourType && { hourType: preObj.hourType }),
    ...(preObj.optionType && { optionType: preObj.optionType }),
    ...(preObj.oodaType && { oodaType: preObj.oodaType }),
    ...(preObj.menuType && { menuType: preObj.menuType }),
    ...(preObj.previousSetStore && {
      previousSetStore: preObj.previousSetStore,
    }),
    ...(preObj.loadTime && { loadTime: preObj.loadTime }),
    ...(preObj.categoryCount && { categoryCount: preObj.categoryCount }),
    ...(preObj.gridType && { gridType: preObj.gridType }),
    ...(preObj.cookinTime && { cookinTime: preObj.cookinTime }),
    ...(preObj.refundAmount && { refundAmount: preObj.refundAmount }),
    ...(preObj.deliveryTime && { deliveryTime: preObj.deliveryTime }),
    ...(preObj.SGTime && { SGTime: preObj.SGTime }),
    ...(preObj.DTime && { DTime: preObj.DTime }),
    ...(preObj.orderId && { orderId: preObj.orderId }),
    ...(preObj.pointsRedemption && {
      pointsRedemption: preObj.pointsRedemption,
    }),
  };
};

const getEcomCategoryFromCode = (code) => {
  let ecomCategory = "";
  if (!code) return ecomCategory;
  if (code.startsWith("PIZ")) {
    ecomCategory = "pizza";
  } else if (code.startsWith("CMB")) {
    ecomCategory = "combo";
  } else if (code.startsWith("BEV")) {
    ecomCategory = "beverage";
  } else if (code.startsWith("CAKE") || code.startsWith("DST")) {
    ecomCategory = "dessert";
  } else {
    ecomCategory = "side";
  }
  return ecomCategory;
};

const getMilestoneStage = (offer) => {
  if (
    offer?.milestonesCouponDTOList &&
    offer.milestonesCouponDTOList.length > 0
  ) {
    for (let i = 0; i < offer.milestonesCouponDTOList.length; i++) {
      let ele = offer.milestonesCouponDTOList[i];
      if (!ele.redeemed) return i + 1;
    }
  } else {
    return 1;
  }
};

const returnsGetItemWQuantity = (cartData, addItemToCart) => {
  let item = [];
  if (cartData) {
    item = cartData.find((i) => i.code == addItemToCart.code);
  }
  if (item) {
    return true;
  } else {
    return false;
  }
};

const jsonParser = (json, defaultVal = {}) => {
  try {
    if (typeof json === "object" || !json) return json;
    return JSON.parse(json);
  } catch (e) {
    return defaultVal;
  }
};

const getSessionStorageValue = (key) => {
  try {
    if (typeof window !== "undefined") {
      return jsonParser(sessionStorage.getItem(key));
    }
  } catch (err) {}
};

const setSessionStorageValue = (key, value) => {
  try {
    if (typeof window !== "undefined") {
      sessionStorage.setItem(key, value);
    }
  } catch (err) {}
};

const replaceToppingText = (cartData, allTopngs, data) => {
  let replaceTopDisplay = "";
  if (cartData.length > 0 && cartData?.length !== undefined) {
    const curObj = cartData[cartData.length - 1];
    const { remTopngs, repTopngs } = curObj;
    if (remTopngs && repTopngs) {
      let removeTop = allTopngs.find(
        (i) => Number(i.toppingId) === Number(curObj["remTopngs"][0]),
      );
      let addTop = allTopngs.find(
        (i) => Number(i.toppingId) === Number(curObj["repTopngs"][0]),
      );
      if (removeTop && addTop) {
        replaceTopDisplay = `${removeTop.name} with ${addTop.name}` || "";
      }
    }
  }
  if (data?.repTopngs?.length !== undefined && data?.repTopngs?.length > 0) {
    return replaceTopDisplay;
  } else {
    return "";
  }
};

const defaultToppingsCustomAtrrArry = (
  currentItemDefaultTopping,
  allTopngs,
) => {
  if (currentItemDefaultTopping && allTopngs) {
    return allTopngs
      .filter((item) => currentItemDefaultTopping.includes(item.toppingId))
      .map((i) => i.custAttrField);
  }
};

const getAddressAlias = (
  stores,
  coords = LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]
    ?.location || "",
) => {
  let footerAddress =
    LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]?.recent
      ?.footerAddress ||
    LocalStorageFunc.getLastLocationNewOrLastLocationNewForIp()[0]?.recent
      ?.city ||
    "";
  let deliveryType = LocalStorageFunc.getDeliveryType();
  if (deliveryType == "P") {
    return "Takeaway from";
  } else if (deliveryType == "DINEIN") {
    return "Dine-in at";
  } else if (deliveryType == "CURB") {
    return "DRIVE-N-PICK";
  } else {
    let userAddresses = localStorage.userAddresses
      ? tryJsonParse(localStorage.userAddresses)
      : "";
    try {
      let address = {};
      if (
        Array.isArray(userAddresses) &&
        userAddresses.length > 0 &&
        coords?.address_id
      ) {
        address = userAddresses.find(
          (item) => item.address_id == coords.address_id,
        );
      } else {
        for (const item of userAddresses) {
          if (
            item.longitude == coords.longitude &&
            item.latitude == coords.latitude
          ) {
            address = item;
          }
        }
      }
      if (Object.keys(address).length > 0) {
        return (
          address.customer_address_name ||
          "Home" ||
          address.footerAddress ||
          address.city
        );
      }
    } catch (err) {}
    if (stores) {
      return (
        stores?.homePageAddress?.topAddress ||
        stores?.city ||
        stores?.footerAddress
      );
    }
    return footerAddress;
  }
};

const findOrdinalsSufixInDate = (day) => {
  // it will set the appropriate string according to day
  let first = Number(day) % 10;
  let second = Number(day) % 100;
  if (first == 1 && second != 11) {
    return "st";
  }
  if (first == 2 && second != 12) {
    return "nd";
  }
  if (first == 3 && second != 13) {
    return "rd";
  }
  return "th";
};

const getNotAvailablePizzaInStore = (storeItem, currentPizza) => {
  const { menuCode, sizeCode } = currentPizza;
  let isAva = [];
  let pizzaCat = ["PIZ"];
  let nonPizzaCat = {
    SIDES: ["BRD", "NVPARCEL", "TACNV", "VGP"],
    BEVRAGES: ["BEV", "CMB", "CAKE", "DST", "SID", "DIP"],
  };
  if (currentPizza !== undefined && storeItem?.length !== undefined) {
    if (pizzaCat[0] === String(currentPizza.menuCode.slice(0, 3))) {
      isAva = storeItem.find((i) => i.code === currentPizza.menuCode);
    } else {
      if (
        nonPizzaCat.BEVRAGES.includes(String(currentPizza.menuCode.slice(0, 3)))
      ) {
        isAva = storeItem.find((i) => i.code === currentPizza.menuCode);
      } else {
        isAva = storeItem.find((i) => {
          if (i.sizeCode == sizeCode) {
            if (i.code == menuCode) {
              return i;
            }
          }
        });
      }
    }
  }
  if (isAva && Object.keys(isAva)?.length > 0) {
    return false;
  } else {
    return true;
  }
};

const getDomain = () => {
  let domain = window.location.host.toString();
  let index = domain.indexOf(".");
  domain = domain.substr(index, domain.length - 1);
  return domain;
};

const setCookie = (name, value, days, domain) => {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie =
    name +
    "=" +
    (value || "") +
    ";domain=" +
    (domain || ".dominos.co.in") +
    expires +
    "; path=/";
};

const getCookie = (c_name) => {
  var i,
    x,
    y,
    ARRcookies = document.cookie.split(";");
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x == c_name) {
      return unescape(y);
    }
  }
};

const deleteCookie = (name, domain) => {
  if (name) {
    document.cookie =
      name +
      "=;expires=Thu,01 Jan 1970 00:00:01 UTC;path=/;domain=" +
      (domain || ".dominos.co.in");
  }
};

const addKeyToCartWhenReloadsData = (arr) => {
  if (arr && arr.length) {
    return arr.map((i) => {
      if (
        (i?.addTopngs?.length !== undefined && i?.addTopngs?.length > 0) ||
        i.defaultSizeName !== i.sizeName ||
        i.defaultCrustName !== i.crustName
      ) {
        return { ...i, isUserCustomizable: true };
      } else {
        return { ...i, isUserCustomizable: false };
      }
    });
  } else {
    return [];
  }
};

const getUrlQueryString = () => {
  let _ = "";
  try {
    var url = window.location.href,
      retObject = {},
      parameters;
    if (url.indexOf("?") === -1) {
      return "";
    }
    url = url.split("?")[1];
    parameters = url.split("&");
    for (var i = 0; i < parameters.length; i++) {
      retObject[parameters[i].split("=")[0]] = parameters[i].split("=")[1];
    }

    _ = "?";
    for (const [key, value] of Object.entries(retObject)) {
      if (key) {
        _ = _ + "&" + key + "=" + value;
      }
    }
  } catch (e) {
    _ = "";
  }

  return _;
};

const getQueryFromUrl = (urlIs = "") => {
  var retObject = {};
  try {
    var url = urlIs || window.location.href,
      parameters;
    if (url.indexOf("?") === -1) {
      return {};
    }
    url = url.split("?")[1];
    parameters = url.split("&");
    for (var i = 0; i < parameters.length; i++) {
      retObject[parameters[i].split("=")[0]] = parameters[i].split("=")[1];
    }
  } catch (e) {
    return {};
  }

  return retObject;
};

const getQueryFromUrlWithSpace = (urlIs = "") => {
  let retObject = {};
  try {
    const urlParams = new URLSearchParams(window.location.search);
    for (const [key, value] of urlParams) {
      retObject[key] = value;
    }
  } catch (e) {
    return {};
  }

  return retObject;
};

const isNoRedirectTrue = () => {
  let queryParams = getQueryFromUrl();
  if (queryParams["noredirect"]) {
    return true;
  } else return false;
};

const checkWindowLocationIncludes = (partial) => {
  return (
    window.location.href.includes(partial) &&
    (window.location.href.includes(partial + "/") ||
      window.location.href.includes(partial + "?") ||
      !window.location.href.split(partial)[1])
  );
};

const isStoreUrlCacheEligible = () => {
  let _ = LocalStorageFunc.getComputedLocationData();
  if (!_?.address_alias) {
    return false;
  }
  if (shouldHideCompleteLocationFlow) {
    return window.location.href.includes(
      getCurrentStoreFolder() + LocalStorageFunc.storeId(),
    );
  }
  return (
    LocalStorageFunc.getIsStoreIdCacheEligible() &&
    window.location.href.includes(
      getCurrentStoreFolder() + LocalStorageFunc.storeId(),
    )
  );
};

// const getBuildVersion = () => {
//   return window?.version ? "?ver=" + window.version : ((window?._siteProps_?.props?.app_version) ? ("?ver=" + window._siteProps_.props.app_version): ("?ver=1.0.0"));
// };

const getSitePropsVersion = () => {
  return window?._siteProps_?.props?.app_version
    ? "?ver=" + window?._siteProps_?.props?.app_version
    : "?ver=1.1.1";
};

const prepareImgPath = (url) => {
  if (url.indexOf("https:") != -1) {
    return url + getSitePropsVersion();
  } else {
    return imgBaseUrl + "/" + url + getSitePropsVersion();
  }
};

const prepareVideoPath = (url) => {
  if (url.indexOf("https:") != -1) {
    return url + getSitePropsVersion();
  } else {
    return imgBaseUrl + "/" + url + getSitePropsVersion();
  }
};

const getProductImages = (imgArr, catg) => {
  const catalogImageBaseUrl =
    store.state.Config?.appConfig?.config?.catalogImageBaseUrl || "";

  if (
    isMenuPage() ||
    getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_LOYALTY
  ) {
    let mediaUrl = "";

    for (let i = 0; i < (imgArr?.length || 0); i++) {
      const item = imgArr[i];
      if (!item || !item.mediaPath) continue;

      if (item.mediaSize === catg || !mediaUrl) {
        mediaUrl = item.mediaPath;
      }
    }

    if (!mediaUrl) return "";

    const isFullUrl =
      typeof mediaUrl === "string" && mediaUrl.startsWith("http");

    let imgUrl;
    if (isFullUrl) {
      imgUrl = catalogImageBaseUrl;
    } else {
      imgUrl = catalogImageBaseUrl + mediaUrl;
    }
    return imgUrl;
  }

  let webp = {},
    jpg = {};
  for (let i = 0; i < imgArr?.length; i++) {
    if (imgArr[i].mediaSize == "Web" + catg) {
      webp = prepareImgPath(imgArr[i].mediaPath);
    } else if (imgArr[i].mediaSize == catg) {
      jpg = prepareImgPath(imgArr[i].mediaPath);
    }
  }
  if (Object.keys(webp).length > 0) {
    return webp;
  } else {
    return jpg;
  }
};

const getProductVideo = (videoArr, catg) => {
  for (let i = 0; i < videoArr.length; i++) {
    if (videoArr[i].mediaSize === catg) {
      return prepareVideoPath(videoArr[i].mediaPath);
    }
  }
};

const checkIfMiniAppSwitch = () =>
  window._siteProps_?.props?.miniAppSwitchNgh === "true";

const getMiniAppStorageVal = () => {
  const miniAppSwitch = checkIfMiniAppSwitch();
  if (miniAppSwitch) {
    return LocalStorageFunc.isMiniAppPaytmGpay();
  } else {
    return false;
  }
};

const checkIfIsMiniApp = (miniApp = getMiniAppStorageVal()) =>
  [MINIAPP.GPAY, MINIAPP.PAYTM].includes(miniApp || "");
const checkIfIsGpay = (miniApp = getMiniAppStorageVal()) =>
  miniApp === MINIAPP.GPAY;
const checkIfIsPAYTM = (miniApp = getMiniAppStorageVal()) =>
  miniApp === MINIAPP.PAYTM;
const storeRegex = /\/store|landing|home[^]*\//gm; //might need to change in future

const addUpdateParam = (url, param, paramValue) => {
  if (url.indexOf("?") !== -1) {
    let queryParams = {};
    let queryUrl = url.split("?");
    let parameters = queryUrl[1].split("&");
    for (var i = 0; i < parameters.length; i++) {
      queryParams[parameters[i].split("=")[0]] = parameters[i].split("=")[1];
    }
    // add/update the param
    queryParams[param] = paramValue;

    let _ = "?";
    for (const [key, value] of Object.entries(queryParams)) {
      if (key) {
        _ = _ + "&" + key + "=" + value;
      }
    }
    return queryUrl[0] + _;
  }
  url = url + "?&" + param + "=" + paramValue;
  return url;
};

const scrollToFromSessionKey = () => {
  let landingPageKey = LocalStorageFunc.getSessionStorageKey("LANDING_PAGE");
  const categoryData = store.state.ProductItems.allCategoryId;
  if (
    typeof landingPageKey === "string" &&
    landingPageKey.startsWith("/menu")
  ) {
    landingPageKey = landingPageKey.replace("/menu", "");
    if (landingPageKey === "") {
      scrollUptoMenuTop();
    } else {
      landingPageKey = landingPageKey.slice(1);
      let landingPageKeyIsNum = /^\d+$/.test(landingPageKey) || false;
      Object.values(categoryData).forEach((val) => {
        let categoryName = val?.categoryName || "";
        categoryName = categoryName.replace(/[^A-Z0-9]+/gi, "-").toLowerCase(); //remove spaces,special-character and replace it with '-' hyphen
        if (
          landingPageKey === categoryName ||
          Number(landingPageKey) === val.categoryId
        ) {
          store.commit(
            keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
            val.categoryName,
          );
          scrollUptoTo("element_catg_" + val.categoryId);
        }
      });
    }
    LocalStorageFunc.unsetSessionStorageKey("LANDING_PAGE");
  }
};

const locationCalls = () => {
  if (window.location.href.includes(getCurrentStoreFolder())) {
    let payload = LocalStorageFunc.getCoordsFromRecentLocation();
    if (payload) {
      payload.source = LocalStorageFunc.getLocationSource();
    }
    if (
      LocalStorageFunc.getDeliveryType() != "D" &&
      LocalStorageFunc.getCoordsForTakeaway()
    ) {
      store.dispatch(
        keyMapsAction.GEO_CODE_API_COMBO,
        LocalStorageFunc.getCoordsForTakeaway(),
      );
    } else if (payload?.source == "ip") {
      if (LocalStorageFunc.getHideLocationPopupOnceFromSession()) {
        store.dispatch(keyMapsAction.GOOGLE_GEO_LOCATION_API, {});
        LocalStorageFunc.unsetSessionStorageKey("hideLocationPopupOnce");
      } else {
        // this.showLocationPermissionModal = true;
        if (LocalStorageFunc.getIsLocationPermisssionGiven()) {
          // this.handleLocationPermissionModal(true);
        } else if (LocalStorageFunc.getAskLocationLaterFromSession()) {
          // this.handleLocationPermissionModal(false);
        }
      }
    } else if (
      payload?.coords?.latitude &&
      LocalStorageFunc.isLocationSelectedFromPwaV2()
    ) {
      store.dispatch(keyMapsAction.GEO_CODE_API_COMBO, payload);
    } else {
      if (!shouldHideCompleteLocationFlow) {
        // this.showLocationPermissionModal = true;
        if (LocalStorageFunc.getIsLocationPermisssionGiven()) {
          // this.handleLocationPermissionModal(true);
        } else if (LocalStorageFunc.getAskLocationLaterFromSession()) {
          // this.handleLocationPermissionModal(false);
        }
      }
    }
  } else {
    window.location.href =
      projectBasePathWithFolder +
      getCurrentStoreFolder() +
      LocalStorageFunc.storeId() +
      getUrlQueryString();
  }
};

const startupAppiCalls = () => {
  store.dispatch(keyMapsAction.LOAD_LOGIN_STATUS, {});
  store.commit(keyMapsMutation.LOAD_CURRENT_ORDER_TYPE, {});
  if (!isStoreUrlCacheEligible()) {
    locationCalls();
  }
  LocalStorageFunc.isLoggedIn() && store.dispatch(keyMapsAction.LOYALITY_API);
  LocalStorageFunc.isLoggedIn() &&
    store.dispatch(keyMapsAction.WALLET_BALANCE_API);
  store.dispatch(keyMapsAction.PIZZA_TOPPING_API);
  store.dispatch(keyMapsAction.WELCOME_OFFER_API, {});
  store.dispatch(keyMapsAction.PERSONALIZATION_API, {});

  let exp = store.state.Config.vwoExperiments;
  store.dispatch(keyMapsAction.MENU_SEQUENCING_API, {});
  /* this.$store.dispatch(keyMapsAction.LEFT_MENU_API, {}); */
};

const getLinkRewriteFromSiteprops = () => {
  return window._siteProps_?.link_rewrite || "";
};

const initializeUtmAttributes = () => {
  const utmAttributes = {
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
  };
  const { utm_source, utm_medium, utm_campaign } =
    LocalStorageFunc.getUtmAttributes() || utmAttributes;
  const queryParams = getQueryFromUrl();
  const {
    utm_source: utmSourceQuery = "direct",
    utm_medium: utmMediumQuery = "direct",
    utm_campaign: utmCampaignQuery = "direct",
  } = queryParams;
  if (
    (utmSourceQuery !== "direct" && utm_source !== utmSourceQuery) ||
    (utmMediumQuery !== "direct" && utm_medium !== utmMediumQuery) ||
    (utmCampaignQuery !== "direct" && utm_campaign !== utmCampaignQuery)
  ) {
    const updatedUtmAttributes = {
      ...utmAttributes,
      utm_source: utmSourceQuery,
      utm_medium: utmMediumQuery,
      utm_campaign: utmCampaignQuery,
      utm_source_medium: `${utmSourceQuery}-${utmMediumQuery}`,
    };
    LocalStorageFunc.setUtmAttributes(updatedUtmAttributes);
    LocalStorageFunc.setUtmTimestamp(new Date().getTime());
  } else {
    const updatedUtmAttributes = {
      utm_source: utm_source || utmSourceQuery,
      utm_medium: utm_medium || utmMediumQuery,
      utm_campaign: utm_campaign || utmCampaignQuery,
      utm_source_medium: `${utm_source || utmSourceQuery}-${
        utm_medium || utmMediumQuery
      }`,
    };
    LocalStorageFunc.setUtmAttributes(updatedUtmAttributes);
  }
  if (
    new Date().getTime() -
      parseInt(LocalStorageFunc.getUtmTimestamp() || "0", 10) >
    3600000 * 48
  ) {
    LocalStorageFunc.setUtmAttributes({
      utm_source: "direct",
      utm_medium: "direct",
      utm_campaign: "direct",
      utm_source_medium: "direct-direct",
    });
  }
};

const checkIfDefaultStoreId = () => {
  const storeid = LocalStorageFunc.storeId();
  if (storeid === Location.defaultStoreId) {
    return true;
  }
  return false;
};

const shouldRedirectToCategory = () => {
  let url = window.location.href;
  if (url.indexOf("?") !== -1) {
    url = url.split("?")[0];
  }
  return (
    (!url.includes(getCurrentStoreFolder()) && !checkIfDefaultStoreId()) ||
    (!url.includes(getCurrentStoreFolder()) && !getNoRedirectFromWindow()) || // when window.noredirect = false redirect -> respective category
    (!url.includes(getCurrentStoreFolder()) &&
      getLinkRewriteFromSiteprops() === "/")
  );
};

const replaceSubstringWithArrayValues = (
  originalSubStr,
  keysArr,
  updatedSubStr,
) => {
  let modifiedString = originalSubStr;
  for (let i = 0; i < keysArr.length; i++) {
    const regex = keysArr[i];
    const updatedValue = updatedSubStr[i] || "";
    modifiedString = modifiedString.replace(regex, updatedValue);
  }

  modifiedString = modifiedString.replace(/\{\:|#\}/g, "");
  return modifiedString;
};

const getProcessedString = (title, respValObj) => {
  const regex = /{:(.*?)#}/g;

  const keysArray = [];
  let match;
  while ((match = regex.exec(title))) {
    keysArray.push(match[1]);
  }

  const replacementValuesArr = keysArray.map((key) => respValObj[key]);
  let updatedStr = replaceSubstringWithArrayValues(
    title,
    keysArray,
    replacementValuesArr,
  );
  return updatedStr;
};

const isKeyAvailAndObjNotEmpty = (obj, key) => {
  return (
    Object.keys(obj).length > 0 && obj.hasOwnProperty(key) && obj[key] !== ""
  );
};

const isPageReloaded = () => {
  return (
    window?.performance?.getEntriesByType("navigation")[0]?.type == "reload"
  );
};

const getMenuCategory = () => {
  const currentLinkRewrite = getLinkRewriteFromSiteprops();
  switch (currentLinkRewrite) {
    case PageNames.NEXTGEN_LINKREWRITE_HOME:
      return `/${homeMenuCategory}/`;
    case PageNames.NEXTGEN_LINKREWRITE_HOME_GUEST:
      return `/${homeGuestMenuCategory}/`;
    default:
      return `/${homeMenuCategory}/`;
  }
};

const promoAppliedFromCartPage = () => {
  const cartData = LocalStorageFunc.getCartData();
  if (
    cartData?.explicitPromo?.promoType === "IMPLICIT" &&
    cartData?.explicitPromo?.promoCode
  ) {
    LocalStorageFunc.updateCouponCode(cartData?.explicitPromo?.promoCode);
  }
};
const isEdvItem = (item) => {
  return (
    item?.explicitPromo?.promoType === "DEAL_EXPLICIT" ||
    item?.promoPerQty?.[0]?.promoType === "DEAL_EXPLICIT"
  );
};

const decryptData = (data) => {
  if (!data) {
    console.error("No data provided for decryption");
    return data;
  }

  try {
    const rawBytes = CryptoJs.AES.decrypt(data, keyForEncryDecry);
    const decryptedDataString = rawBytes.toString(CryptoJs.enc.Utf8);
    const decryptedData = JSON.parse(decryptedDataString);

    return decryptedData;
  } catch (error) {
    console.error("Error decrypting data:", error);
    return data;
  }
};

const encryptData = (data, key) => {
  try {
    const dataString = JSON.stringify(data); //obj
    const encryptedData = CryptoJs.AES.encrypt(
      dataString,
      keyForEncryDecry,
    ).toString();

    return encryptedData;
  } catch (error) {
    console.error("Error encrypting data:", error);
    return data;
  }
};

const getNextGenTntUrl = () => {
  return (
    paymentsProjectBasePathWithFolder +
    `/${PageNames.NEXTGEN_LINKREWRITE_NG_POSTORDER}` +
    getUrlQueryString()
  );
};

const timeoutPromise = (ms) => {
  return new Promise((_, reject) => {
    setTimeout(() => {
      reject(new Error("Operation timed out"));
    }, ms);
  });
};

const getUTCMilliseconds = () => new Date().getUTCMilliseconds();

const getNextGenCartUrl = () => {
  return (
    paymentsProjectBasePathWithFolder +
    `/${PageNames.NEXTGEN_LINKREWRITE_CART}/` +
    LocalStorageFunc.storeId() +
    getUrlQueryString()
  );
};

const isCartQtyLimitError = () => {
  if (!isCorporateSite) return false;
  const cartItems = LocalStorageFunc.cart();
  let cartQty = 0;
  cartItems.forEach((item) => {
    cartQty += item.quantity;
  });
  if (cartQty > corporateOrderQtyLimit) {
    return true;
  }
  return false;
};

const showCartQtyLimitError = () => {
  const errorObj = {
    msg: `Your order has higher number of items than allowed per order. Please break it into multiple orders of total item quantity not greater than ${corporateOrderQtyLimit}.`,
    cta: "Okay",
  };
  store.commit(keyMapsMutation.UPDATE_SHOW_ALERT_MODAL, true);
  store.commit(keyMapsMutation.UPDATE_ALERT_MODAL_MSG, errorObj);
};

const sendToNextGenCart = () => {
  if (isCartQtyLimitError()) {
    showCartQtyLimitError();
    return;
  }

  window.location.href = getNextGenCartUrl();
  return;
};

const translateNewResponseToOldResponseCoupon = (newResponse) => {
  const BLANK_STRING = "";
  const {
    coupons = [],
    timestamp = BLANK_STRING,
    status = "",
  } = newResponse || {};

  if (newResponse && (coupons != undefined || coupons != null)) {
    const updatedCoupons =
      coupons && Array.isArray(coupons)
        ? coupons.map((couponItem) => {
            const {
              category = BLANK_STRING,
              displayTitle = BLANK_STRING,
              displayTitleVisible = BLANK_STRING,
              properties = BLANK_STRING,
              data = [],
            } = couponItem;

            const newCouponItem = {};

            const newData = data.map((offer) => {
              const tempOffer = {};

              tempOffer["couponCode"] = offer.couponCode;
              tempOffer["promoCode"] = offer.couponCode;
              tempOffer["title"] = offer.metaData?.name || BLANK_STRING;
              tempOffer["timestamp"] = timestamp;
              tempOffer["confettiTitle"] =
                offer.staticMessages?.confettiMessage || BLANK_STRING;
              tempOffer["confettiMessage"] =
                offer.staticMessages?.confettiMessage || BLANK_STRING;
              tempOffer["defaultSavingMessage"] =
                offer.metaData?.savingsMessage || BLANK_STRING;
              tempOffer["exactSavingMessage"] =
                offer.staticMessages?.savingsMessage || BLANK_STRING;
              tempOffer["htmlSavingMessage"] =
                offer.staticMessages?.htmlMessage || BLANK_STRING;
              tempOffer["defaultHtmlMessage"] =
                offer.metaData?.savingsHtmlMessage || BLANK_STRING;
              tempOffer["description"] = offer.description;

              if (offer.metaData?.iconURL) {
                tempOffer["iconURL"] = offer.metaData.iconURL;
              } else if (offer.paymentOffersMetadata?.logo) {
                tempOffer["iconURL"] = [
                  {
                    link: offer.paymentOffersMetadata.logo,
                  },
                ];
              } else {
                tempOffer["iconURL"] = null;
              }

              tempOffer["tnc"] = offer.tnc;
              tempOffer["expiryTimer"] = offer.expiryTimer || {
                days: 0,
                hours: 0,
              };
              tempOffer["messages"] = offer.messages;
              tempOffer["offerOptions"] = offer.offerOptions;
              tempOffer["node"] = offer.node;
              tempOffer["paymentIcon"] = offer.paymentOffersMetadata?.logo;
              tempOffer["paymentId"] = offer.paymentOffersMetadata?.paymentId;
              tempOffer["paymentOptions"] = null;
              tempOffer["paymentMode"] =
                offer.paymentOffersMetadata?.paymentMode;
              tempOffer["paymentLabel"] =
                offer.paymentOffersMetadata?.paymentModeName;

              tempOffer["couponDetail"] = undefined;
              tempOffer["cta"] = null;
              tempOffer["displayMsgOnSelection"] =
                offer.displayText?.messageOnSelection;
              tempOffer["isEnabled"] = offer.applicable;
              tempOffer["isMediumToRegularCoupon"] = false;
              tempOffer["visible"] = offer.applicable;
              tempOffer["errorMessage"] = null;
              tempOffer["isShowError"] = false;

              tempOffer["labelType"] =
                Array.isArray(offer.offerOptions) &&
                offer.offerOptions.length > 0
                  ? "General_Milestone"
                  : "Others";

              tempOffer["milestonesCouponDTOList"] = null;
              tempOffer["nudgeMessage"] = null;
              tempOffer["nudgeMessageType"] = null;
              tempOffer["offerStripMessage"] = offer.displayText?.popupHeader;
              tempOffer["priority"] = offer.metaData?.priority || 0;
              tempOffer["personalized"] = !!(
                offer.personalCouponCode && offer.personalCouponCode.length > 0
              );
              tempOffer["subTitle"] = null;

              const CodeStatus = {
                APPLIED: "APPLIED",
                REJECTED: "REJECTED",
              };
              tempOffer["status"] = offer.applicable
                ? CodeStatus.APPLIED
                : CodeStatus.REJECTED;

              tempOffer["campaignId"] = offer.campaignId;
              tempOffer["isExclusiveCoupon"] =
                offer.metaData?.exclusiveTagged === true &&
                offer.metaData?.reserveCoupon === true;

              return tempOffer;
            });

            newCouponItem["displayLabel"] = displayTitle;
            newCouponItem["displayLabelVisible"] = displayTitleVisible;
            newCouponItem["key"] = category;
            newCouponItem["title"] = displayTitle;
            newCouponItem["list"] = newData;

            return newCouponItem;
          })
        : coupons;

    let dataArr = [];
    updatedCoupons.forEach((item) => {
      if (item.list && Array.isArray(item.list) && item.list.length) {
        dataArr = [...dataArr, ...item.list];
      }
    });

    return {
      coupons: dataArr,
      status: status,
    };
  } else {
    return newResponse;
  }
};

const getNxgMiddlewareHeaders = () => {
  const tenantKey = envConfig.TENANT_KEY || "";
  const userDataFromStorage = LocalStorageFunc.getUserData().userData || {};
  const loyaltyProgramCode =
    window?._siteProps_?.props?.loyaltyProgramCode || "";
  let mobile = "";

  if (userDataFromStorage) {
    if (typeof userDataFromStorage === "object") {
      mobile = userDataFromStorage?.mobile || "";
    } else if (typeof userDataFromStorage === "string") {
      const userDataHeaders = decryptData(userDataFromStorage) || {};
      mobile = userDataHeaders?.mobile || "";
    }
  }

  const extraHeader = {
    mobile: mobile,
    orderType: LocalStorageFunc.getDeliveryType(),
    payment_mode: LocalStorageFunc.getPaymentOfferMode()?.paymentMode,
    loyaltyProgramCode: loyaltyProgramCode,
    tenantKey: tenantKey,
    ab_test_variant: JSON.stringify({
      vwo_next_gen_cart_variant:
        window._siteProps_?.props?.ab_test_variant || "",
    }),
  };

  return extraHeader;
};

const normalizeArray = (arr) => arr.map(Number).sort((x, y) => x - y);

const areArraysEqual = (a = [], b = []) => {
  if (a.length !== b.length) return false;
  const aSorted = normalizeArray(a);
  const bSorted = normalizeArray(b);
  return aSorted.every((val, i) => val === bSorted[i]);
};

const ORDER_STATUS_DEL = {
  1: "Order Confirmed",
  2: "Being Baked",
  4: "Dispatched",
  5: "Cancelled",
  9: "Delivered",
  10: "Advance Order",
  11: "Reached Gate",
};

const arrivalStatus = {
  onTime: "ON_TIME",
  beforeTime: "BEFORE_TIME",
  delay: "SLIGHT_DELAY",
  extremeDelay: "DELAYED",
};

const tntLang = {
  arrivingIn: "Arriving in",
  deliveredIn: "Delivered in",
};

export const fireHomeTrackAmplitudeEvent = (
  eventName,
  eventCategory,
  orderData,
  orderSummary,
  currentIndex,
  order_recieved_feedback = "",
  order_count = 0,
) => {
  const orderStatusCode = orderData?.orderStatusCode || 0;
  const eta = orderData?.etaWidget?.eta?.eta;
  const isSgFulfilled = orderData?.sgFulfilled || false;
  const arrivalTimeStatus = orderData?.etaWidget?.eta?.timeStatus || "";

  const eventObj = {
    Event_Category: eventCategory,
    Event_Action: `Active Order Count - ${order_count}`,
    Event_Label: `Index of Order - ${currentIndex + 1}`,
    ...(order_recieved_feedback && { order_recieved_feedback }),
    order_status: ORDER_STATUS_DEL[orderData?.orderStatusCode || 1],
    order_id: orderSummary?.orderId || "",
    amount: orderSummary?.finalPrice || 0,
    items: orderSummary?.items?.length || 0,
    delay_status:
      arrivalTimeStatus == arrivalStatus.onTime ||
      arrivalTimeStatus == arrivalStatus.beforeTime
        ? "no"
        : "yes",
    delay_reason: orderData?.etaWidget?.orderTrackingMessages?.messages || [],
    service_guarentee_mins: orderSummary?.timeServiceGuarantee?.type || "",
    time_loader_status:
      orderStatusCode < 9 ? tntLang.arrivingIn : tntLang.deliveredIn,
    eta_delivery_time: eta || 0,
    sg_met_tag: isSgFulfilled ? "yes" : "no",
    delay_slight_delay:
      arrivalTimeStatus == arrivalStatus.delay
        ? "slight delay"
        : arrivalTimeStatus == arrivalStatus.extremeDelay
          ? "extreme delay"
          : "",
    screenName: "Order Success Screen",
    previousScreenName: "",
  };
  setEvents("amplitude", eventName, eventObj);
};

export const fireSgOneClickAmplitudeEvent = (
  eventName,
  ScreenName,
  userAction,
  category,
  sgRefundAmt,
  service_guarentee_mins = 0,
  eventLabel = "",
) => {
  const eventObj = {
    user_action: userAction,
    HRNN_applicable_status: "Failed",
    SG_refund_amount: sgRefundAmt || 0,
    ...(service_guarentee_mins && { service_guarentee_mins }),
    ScreenName,
    category,
    ...(eventLabel && { eventLabel }),
    Events_time_stamp: new Date().getTime(),
    previousScreenName: "",
  };

  setEvents("amplitude", eventName, eventObj);
};

export const validateXlabsTimeDiff = (time1, time2) => {
  if (!time1 || !time2) return true;
  // Calculate the absolute difference in milliseconds
  const differenceInMillis = Math.abs(time1 - time2);

  // Convert 5 minutes to milliseconds (5 * 60 * 1000)
  const fiveMinutesInMillis = 5 * 60 * 1000;

  // Compare the difference with 5 minutes in milliseconds
  return differenceInMillis > fiveMinutesInMillis;
};

const isCorporateOrderingDisabled = () => {
  const corpUserInfo = LocalStorageFunc.getCorporateUserInfo();
  const inputConfig = Array.isArray(corpUserInfo?.corporateConfig)
    ? corpUserInfo.corporateConfig.find(
        (config) => config.configKey === "appDisableConfig",
      ).configValue
    : {};
  const config = {
    specialDates: [],
    yearlyDates: [],
    monthlyDates: [],
    dailySlots: [],
    ...inputConfig,
  };

  const now = new Date();
  const nowMs = now.getTime();
  const nowYear = now.getFullYear();
  const nowMonth = now.getMonth();
  const nowDate = now.getDate();

  const within = (start, end) => {
    if (start <= end) return nowMs >= start && nowMs <= end;
    return nowMs >= start || nowMs <= end;
  };

  for (const { start, end, displayMsg, description } of config.specialDates) {
    const startMs = new Date(
      start.year,
      start.month - 1,
      start.day,
      start.hour,
      start.minute || 0,
    ).getTime();
    const endMs = new Date(
      end.year,
      end.month - 1,
      end.day,
      end.hour,
      end.minute || 0,
    ).getTime();
    if (within(startMs, endMs))
      return { disable: true, displayMsg, description };
  }

  for (const { start, end, displayMsg, description } of config.yearlyDates) {
    const startMs = new Date(
      nowYear,
      start.month - 1,
      start.day,
      start.hour,
      start.minute || 0,
    ).getTime();
    const endMs = new Date(
      nowYear,
      end.month - 1,
      end.day,
      end.hour,
      end.minute || 0,
    ).getTime();
    if (within(startMs, endMs))
      return { disable: true, displayMsg, description };
  }

  for (const { start, end, displayMsg, description } of config.monthlyDates) {
    const startMs = new Date(
      nowYear,
      nowMonth,
      start.day,
      start.hour,
      start.minute || 0,
    ).getTime();
    const endMs = new Date(
      nowYear,
      nowMonth,
      end.day,
      end.hour,
      end.minute || 0,
    ).getTime();
    if (within(startMs, endMs))
      return { disable: true, displayMsg, description };
  }

  for (const { start, end, displayMsg, description } of config.dailySlots) {
    const startMs = new Date(
      nowYear,
      nowMonth,
      nowDate,
      start.hour,
      start.minute || 0,
    ).getTime();
    const endMs = new Date(
      nowYear,
      nowMonth,
      nowDate,
      end.hour,
      end.minute || 0,
    ).getTime();
    if (within(startMs, endMs))
      return { disable: true, displayMsg, description };
  }

  return { disable: false, displayMsg: null, description: null };
};

const showCorporateDisabledError = (error) => {
  const errorObj = {
    msg: `${error.description}. ${error.displayMsg}`,
    cta: "Okay",
    reload: true,
  };
  store.commit(keyMapsMutation.UPDATE_SHOW_ALERT_MODAL, true);
  store.commit(keyMapsMutation.UPDATE_ALERT_MODAL_MSG, errorObj);
};

export const convertValidItemsToFinalData = (validItems) => {
  let items = validItems;

  if (typeof items === "string") {
    try {
      items = JSON.parse(items);
    } catch (e) {
      //console.warn("convertValidItemsToFinalData: invalid JSON string", e, items);
      return {};
    }
  }

  if (!Array.isArray(items)) {
    //console.warn("convertValidItemsToFinalData expected an array, got:", items);
    return {};
  }

  return validItems.reduce((acc, item) => {
    const pm = item?.productMetadata ?? {};
    const menu = pm?.productMenuMetadata ?? {};

    const crustAttr = pm?.productAttributes?.find((a) => a?.key === "crust");
    const sizeAttr = pm?.productAttributes?.find((a) => a?.key === "size");
    const crustIdRaw =
      crustAttr?.metadata?.find((md) => md?.name === "crustId")?.values?.[0] ??
      null;
    const sizeIdRaw =
      sizeAttr?.metadata?.find((md) => md?.name === "sizeId")?.values?.[0] ??
      null;
    const crustCode =
      crustAttr?.metadata?.find((md) => md?.name === "code")?.values ?? [];
    const sizeServes =
      sizeAttr?.metadata?.find((md) => md?.name === "serves")?.values ?? [];
    const selectedCrust = crustAttr?.value ?? "";
    const selectedSize = sizeAttr?.value ?? "";

    const crustIdStr = crustIdRaw != null ? String(crustIdRaw) : null;
    const sizeIdStr = sizeIdRaw != null ? String(sizeIdRaw) : null;

    const sizeCode =
      pm?.properties?.find((p) => p?.key === "size_code")?.values?.[0] ?? "";

    const taxation = pm?.taxationDetails?.length
      ? [
          {
            taxes: pm.taxationDetails.map((t) => ({
              name: t?.key === "GST" ? "Tax" : (t?.key ?? ""),
              value: (t?.value ?? "").replace(/\.0$/, ""),
            })),
          },
        ]
      : [];

    const currentPriceCalc = item?.calculations?.find(
      (c) => c?.key === "current_price",
    )?.amount;
    const unitRegularCalc = item?.calculations?.find(
      (c) => c?.key === "unit_regular_price",
    )?.amount;

    const priceCurrent = currentPriceCalc ?? pm?.currentPrice ?? 0;
    const variantRegular = unitRegularCalc ?? pm?.regularPrice ?? 0;

    const attributes = [];
    if (crustAttr) {
      attributes.push({
        name: "Crust",
        values: [
          {
            metadataMap: {
              code: {
                values: Array.isArray(crustCode) ? crustCode : [crustCode],
              },
              crustId: {
                values: crustIdStr
                  ? [
                      Number.isNaN(+crustIdStr)
                        ? crustIdStr
                        : Number(crustIdStr),
                    ]
                  : [],
              },
            },
            name: selectedCrust,
            values: sizeAttr
              ? [
                  {
                    metadataMap: {
                      sizeId: {
                        values: sizeIdStr
                          ? [
                              Number.isNaN(+sizeIdStr)
                                ? sizeIdStr
                                : Number(sizeIdStr),
                            ]
                          : [],
                      },
                      serves: { values: sizeServes },
                    },
                    name: selectedSize,
                  },
                ]
              : [],
          },
        ],
      });
    }
    if (sizeAttr) {
      attributes.push({
        name: "Size",
        values: [
          {
            metadataMap: {
              sizeId: {
                values: sizeIdStr
                  ? [Number.isNaN(+sizeIdStr) ? sizeIdStr : Number(sizeIdStr)]
                  : [],
              },
              serves: { values: sizeServes },
            },
            name: selectedSize,
          },
        ],
      });
    }

    const variants = [
      {
        defaultVariant: true,
        price: {
          regularPrice: variantRegular,
        },
        attributes: [
          {
            name: "Crust",
            value: selectedCrust,
            metadataMap: {
              crustId: { values: crustIdStr ? [crustIdStr] : [] },
            },
          },
          {
            name: "Size",
            value: selectedSize,
            metadataMap: {
              sizeId: { values: sizeIdStr ? [sizeIdStr] : [] },
            },
          },
        ],
      },
    ];

    const customisedAddOns = pm?.customisedAddOns ?? [];
    const addTopngs = [];
    const remTopngs = [];
    const repTopngs = [];
    const selectedToppingDetails = [];
    const remToppingsDetails = [];
    const repToppingsDetails = [];

    customisedAddOns.forEach((addon) => {
      const toppingId = addon?.toppingId;

      if (addon?.quantity > 0 && !addon?.replaceAddOn) {
        if (toppingId) addTopngs.push(String(toppingId));
        selectedToppingDetails.push({
          toppingId: String(toppingId ?? ""),
          displayName: addon?.name ?? "",
          price: addon?.currentPrice?.chargesWith ?? 0,
        });
      }

      if (addon?.replaceAddOn) {
        const removed = addon.replaceAddOn;

        if (removed?.toppingId) remTopngs.push(String(removed.toppingId));
        remToppingsDetails.push({
          itemId: String(removed?.id ?? ""),
          displayName: removed?.name ?? "",
          price: removed?.currentPrice?.chargesWith ?? 0,
        });

        if (toppingId) repTopngs.push(String(toppingId));
        repToppingsDetails.push({
          itemId: String(addon?.id ?? ""),
          displayName: addon?.name ?? "",
          price: addon?.currentPrice?.chargesWith ?? 0,
        });
      }
    });

    const foodLabel = pm?.properties?.find((p) => p?.key === "food_label")
      ?.values?.[0];
    const isVeg = !(foodLabel === "NONVEG");

    const converted = {
      parentSkuId: Number(item?.productMasterId) || null,
      crustId: crustIdStr,
      sizeId: sizeIdStr,
      name: pm?.name ?? "",
      displayName: pm?.name ?? "",
      description: pm?.longDescription ?? pm?.description ?? "",
      menuCode: menu?.menuCode ?? "",
      sizeCode,
      price: { currentPrice: priceCurrent },
      attributes,
      metadataMap: pm?.metadataMap ?? {},
      taxation,
      variants,
      isVeg,
      selectedCrust,
      selectedSize,
      quantity: item?.quantity ?? 1,
      addTopngs,
      remTopngs,
      repTopngs,
      selectedToppingDetails,
      remToppingsDetails,
      repToppingsDetails,
    };

    const key = String(item?.productMasterId);
    if (!acc[key]) acc[key] = [];
    acc[key].push(converted);
    return acc;
  }, {});
};

const getOrderedMenuCategories = (productItems, categorySequence) => {
  let finalObj = {};
  const items = productItems || {};
  const sequence = categorySequence || [];

  sequence.forEach((key) => {
    const item = items[key];
    // Check if item exists + is not 9999 + has data + is explicitly shown
    if (
      item &&
      item.categoryId !== 9999 &&
      Object.keys(item.data || {}).length > 0 &&
      item.showCategory === true
    ) {
      finalObj[key] = item;
    }
  });

  return finalObj;
};

const addQueryParams = (url) => {
  let currentUrl = window.location.href;
  let currentQueryParams = getQueryFromUrl(currentUrl);
  let queryParams = getQueryFromUrl(url);
  // in case both have query parameters
  if (currentUrl.indexOf("?") !== -1) {
    if (currentQueryParams["redirectUrl"]) {
      delete currentQueryParams["redirectUrl"];
    }
    let newQuery = getQueryFromQueryParameters(
      Object.assign({}, currentQueryParams, queryParams),
    );
    if (newQuery.length > 0) {
      return url.split("?")[0] + "?" + newQuery;
    } else {
      return url.split("?")[0];
    }
  } else {
    return url;
  }
};

const getQueryFromQueryParameters = (params) => {
  let paramKeys = Object.keys(params);
  let query = "";
  paramKeys.map((item, index) => {
    if (index !== paramKeys.length - 1 && params[item] !== undefined) {
      query = query + item + "=" + params[item] + "&";
    } else if (params[item] !== undefined) {
      query = query + item + "=" + params[item];
    }
  });
  return query;
};

const getSafeRedirectUrl = () => {
  const search = window.location.search;
  const redirectIndex = search.indexOf("redirectUrl=");

  if (redirectIndex === -1) return null;

  const redirectUrl = decodeURIComponent(
    search.substring(redirectIndex + "redirectUrl=".length),
  );

  try {
    const url = new URL(redirectUrl);

    if (
      url.hostname === window.location.hostname ||
      url.hostname.endsWith(`.${window.location.hostname}`)
    ) {
      return url.href;
    }
  } catch {}

  return null;
};

const redirectToHomeOrRedirectUrl = (updateParam = []) => {
  let searchQuery = window.location.search;
  let redirectUrl = getSafeRedirectUrl();
  if (updateParam.length) {
    if (searchQuery.length && redirectUrl && LocalStorageFunc.isLoggedIn()) {
      let newUrl = addQueryParams(redirectUrl);
      updateParam.map((param) => {
        newUrl = addUpdateParam(newUrl, param.name, param.value);
      });
      window.location.href = newUrl;
    } else {
      let url =
        projectBasePathWithFolder + "/home/" + LocalStorageFunc.storeId();
      let newUrl = addQueryParams(url);
      updateParam.map((param) => {
        newUrl = addUpdateParam(newUrl, param.name, param.value);
      });
      window.location.href = newUrl;
    }
  } else {
    if (searchQuery.length && redirectUrl && LocalStorageFunc.isLoggedIn()) {
      window.location.href = addQueryParams(redirectUrl);
    } else {
      let url =
        projectBasePathWithFolder + "/home/" + LocalStorageFunc.storeId();
      window.location.href = addQueryParams(url);
    }
  }
};

const hydrateCartItemsWithProductData = (cartItems, productDataList) => {
  let isModified = false;

  let apiList = Array.isArray(productDataList)
    ? productDataList
    : productDataList?.data || productDataList?.results || [productDataList];

  cartItems.forEach((cartItem) => {
    if (!cartItem || !cartItem.menuCode) return;

    const apiItem = apiList.find((p) => {
      const apiMenuCode = p.metadataMap?.menuCode?.values?.[0];
      return apiMenuCode === cartItem.menuCode;
    });

    if (!apiItem) return;
  });

  if (
    !Array.isArray(cartItems) ||
    !cartItems.length ||
    !Array.isArray(apiList) ||
    !apiList.length
  ) {
    return { hydratedCart: cartItems, isModified: false };
  }

  const keysToInject = [
    "image",
    "cartImage",
    "images",
    "videos",
    "description",
    "buttonText",
    "productModel",
    "deliveryType",
    "sortOrder",
    "productType",
    "defaultCrustName",
    "defaultSizeName",
    "code",
    "taxPercentage",
    "cessPercentage",
    "taxes",
    "taxation",
    "crust",
    "allowedToppings",
    "defaultToppings",
    "heroToppings",
    "filters",
    "categoryIdSet",
    "tags",
    "ratings",
    "disableClick",
    "isReplaceable",
    "isCustomizable",
    "showOnDMB",
    "menuCategoryCode",
    "foodLabel",
    "foodType",
    "menuCategory",
    "topPickTags",
    "Allergen",
  ];

  const keysToPreserve = [
    "id",
    "name",
    "selectedCrust",
    "selectedCrustId",
    "crustId",
    "selectedSize",
    "selectedSizeId",
    "sizeId",
    "addTopngs",
    "remTopngs",
    "repTopngs",
    "quantity",
    "isFromCart",
  ];

  cartItems.forEach((cartItem) => {
    if (!cartItem || !cartItem.id) return;

    const apiItem = apiList.find((p) => {
      if (Number(p.id) === Number(cartItem.id)) return true;

      const apiMenuCode = p.metadataMap?.menuCode?.values?.[0];
      // console.log(`[MATCHED] via id or menuCode. API menuCode: ${apiMenuCode}, Cart menuCode: ${cartItem.menuCode}`);

      return apiMenuCode && apiMenuCode === cartItem.menuCode;
    });

    //const apiItem = apiList.find((p) => Number(p.id) === Number(cartItem.id));
    if (!apiItem) return;

    keysToInject.forEach((key) => {
      //if the cart item is MISSING this key
      if (cartItem[key] === undefined && apiItem[key] !== undefined) {
        cartItem[key] =
          typeof apiItem[key] === "object" && apiItem[key] !== null
            ? JSON.parse(JSON.stringify(apiItem[key]))
            : apiItem[key];

        isModified = true;
      } else if (cartItem[key] !== undefined) {
        //console.log(`Key "${key}" already exists in cart item with value:`, cartItem[key]);
      }
    });

    if (cartItem.catalogProductId === undefined && apiItem.id) {
      cartItem.catalogProductId = apiItem.id;
      isModified = true;
    }

    if (
      cartItem.itemPrice === undefined &&
      cartItem.price?.currentPrice !== undefined
    ) {
      cartItem.itemPrice = cartItem.price.currentPrice;
      isModified = true;
    }

    if (cartItem.sizeName === undefined && cartItem.selectedSize) {
      cartItem.sizeName = cartItem.selectedSize;
      isModified = true;
    }

    if (cartItem.crustName === undefined && cartItem.selectedCrust) {
      cartItem.crustName = cartItem.selectedCrust;
      isModified = true;
    }

    //need to check this
    // if (cartItem.defaultPrice === undefined) {
    //   cartItem.defaultPrice = 999;
    //   isModified = true;
    // }

    // if (cartItem.customCategoryName === undefined) {
    //   cartItem.customCategoryName = "Category Placeholder";
    //   isModified = true;
    // }
  });

  return {
    hydratedCart: cartItems,
    isModified,
  };
};

const sortLoyaltyItems = (obj = {}, key1, key2, order = "asc") => {
  if (!key1 || !key2) {
    return Object.keys(obj) || [];
  }
  const arr = Object.keys(obj) || [];

  return [...arr].sort((a, b) => {
    const diff1 = obj[a][key1] - obj[b][key1];
    if (diff1 !== 0) {
      return order === "asc" ? diff1 : -diff1;
    }

    const diff2 = obj[a][key2] - obj[b][key2];
    return order === "asc" ? diff2 : -diff2;
  });
};

const isRelayPage = () => {
  if (
    [PageNames.NEXTGEN_LINKREWRITE_RELAY].includes(
      getLinkRewriteFromSiteprops(),
    )
  ) {
    return true;
  }
  return false;
};

const getSkuId = (cartItem) => {
  const {
    parentSkuId,
    crustId,
    sizeId,
    explicitPromo,
    childLineItems,
    productMetadata,
    potpFreeItem = false,
    skuId = "",
    id = "",
  } = cartItem;
  if (crustId && sizeId) {
    return `${sizeId}#${crustId}#${skuId || id}`;
  }

  // Fallback
  return skuId || id;
};
const prepareProductDefinitionObjForApp = () => {
  const cartItems = store.state.Cart?.cartItems || [];
  const loyaltyProductsData = store.state.Loyalty.loyaltyProductsData || {};
  const { productDefinitions = [] } = loyaltyProductsData;
  if (
    !cartItems ||
    cartItems.length == 0 ||
    !productDefinitions ||
    productDefinitions.length === 0
  ) {
    return [];
  } else {
    const dataToSendProductDefinitions = [];
    cartItems.forEach((item) => {
      if (!item.potpFreeItem) {
        return;
      }
      const completeSkuId = getSkuId(item);
      const cartProductMasterUID = item.parentSkuId;
      const prodDefSingleObjArray = productDefinitions.filter(
        (i) => i.parentSkuId === cartProductMasterUID,
      );
      const prodDefSingleObj =
        prodDefSingleObjArray && prodDefSingleObjArray.length
          ? prodDefSingleObjArray[0]
          : {};
      if (completeSkuId) {
        const { variants = [] } = prodDefSingleObj || {};
        const selectedVariant =
          variants.find((v) => {
            return v.defaultVariant || v.skuId == completeSkuId;
          }) || variants[0];

        const temp = prodDefSingleObj && deepCopyArry(prodDefSingleObj);
        // temp.variants = prodDefSingleObj.variants?.map((variant) => {
        //   if (variant.skuId == completeSkuId) {
        //     return {
        //       ...variant,
        //       quantity: item.quantity,
        //       potpFreeItem: true,
        //     };
        //   } else {
        //     return variant;
        //   }
        // });
        temp.variants = [
          {
            ...selectedVariant,
            quantity: item.quantity,
            potpFreeItem: true,
          },
        ];
        dataToSendProductDefinitions.push(temp);
      }
    });
    return dataToSendProductDefinitions;
  }
};

const redirectionMultiAsset = (actionObj = {}, goBack = false) => {
  const queryObj = getQueryFromUrlWithSpace(window.location.href);
  const assetName = queryObj["platform"];
  const {
    action = "",
    href = "",
    title = "",
    obj = {},
    closeScreen = "true",
  } = actionObj;
  let updatedHref = href || "";
  let data = {};
  let actionData = {};
  if (assetName) {
    data =
      obj && Object.keys(obj).length
        ? obj
        : prepareProductDefinitionObjForApp() || {};

    actionData = {
      links: [
        {
          title: title,
          updatedHref: updatedHref,
          action: goBack ? "pageClose" : action,
          closeScreen: closeScreen,
          data: data,
        },
      ],
    };
  }

  let redirectUrl = getSafeRedirectUrl();
  if (redirectUrl && action !== "loginsheet") {
    const url = addQueryParams(redirectUrl);
    const updatedUrl = new URL(url, window.location.origin);
    updatedUrl.searchParams.delete("page");
    window.location.href = updatedUrl.toString();
    return;
  }

  if (assetName?.toLowerCase() === "ios") {
    const assetPrefix = window.webkit?.messageHandlers;
    if (assetPrefix && assetPrefix["pwaActions"]) {
      assetPrefix["pwaActions"]["postMessage"](JSON.parse(JSON.stringify(actionData)));
    }
  } else if (assetName?.toLowerCase() === "android") {
    if (window.Android && window.Android["pwaActions"]) {
      window.Android["pwaActions"](JSON.stringify(actionData));
    }
  } else {
    const cartFlag = LocalStorageFunc.getStorageValue("isFromNxgCart");
    const cartQtyZero = store.getters[keyMapsGetter.CART_QUANTITY] || 0;
    if (cartQtyZero == 0) {
      localStorage.removeItem("showLoyaltyToastMsg");
    }
    if (action === "cart" || cartFlag == "true") {
      sendToNextGenCart();
    } else if (action === "menu") {
      sendToMenuScreen();
    } else if (action === "loginsheet") {
      sendToLoginScreen();
    } else if (action === "quitLoyalty") {
      redirectToHomeOrRedirectUrl();
    } else if (goBack) {
      let linkRewrite = LocalStorageFunc.getSessionStorageKey(
        "previousLinkRewrite",
      );
      if (
        !linkRewrite ||
        (typeof linkRewrite === "object" &&
          Object.keys(linkRewrite).length <= 0)
      ) {
        linkRewrite = PageNames.NEXTGEN_LINKREWRITE_HOME;
      }
      const url =
        projectBasePathWithFolder +
        "/" +
        linkRewrite +
        "/" +
        LocalStorageFunc.storeId();
      window.location.href = url;
    }
  }
};

const loyaltyProductMenuType = (currentMenuType = "") => {
  const nxgLoyalty = store.state.Config?.appConfig?.config?.nxgLoyalty || "";
  const asset = window?._siteProps_?.platform;
  let flag = nxgLoyalty
    ?.split(",")
    ?.some((item) => item.toLowerCase() === asset.toLowerCase());

  let loyaltyMenuTypeDefault = flag ? "LOYALTY_V1" : "LOYALTY";
  let loyaltyMenuType = "";
  try {
    let loyaltyMetadata = null;
    if (isLoyaltyPage()) {
      loyaltyMetadata =
        store.state.User?.walletBalance?.loyaltyProgram?.programConfig || {};
      loyaltyMenuType = loyaltyMetadata?.menuType;
    } else {
      loyaltyMetadata =
        tryJsonParse(localStorage.lastLocationNew)[0]?.recent
          ?.loyaltyMetadata || [];
      if (
        loyaltyMetadata &&
        Array.isArray(loyaltyMetadata) &&
        loyaltyMetadata.length
      ) {
        loyaltyMenuType = loyaltyMetadata[0]?.menuType;
      }
    }

    return loyaltyMenuType || loyaltyMenuTypeDefault;
  } catch {
    return loyaltyMenuType || loyaltyMenuTypeDefault;
  }
};

const sendEventToApp = (eventType, eventObj = {}) => {
  const queryObj = getQueryFromUrlWithSpace(window.location.href);
  const assetName = queryObj["platform"];
  const actionData = {
    eventCategory: "amplitude",
    eventName: eventType,
    values: eventObj,
  };

  if (assetName?.toLowerCase() === "ios") {
    const assetPrefix = window.webkit?.messageHandlers;
    if (assetPrefix && assetPrefix["pwaAmpEvents"]) {
      assetPrefix["pwaAmpEvents"]["postMessage"](actionData);
    }
  } else if (assetName?.toLowerCase() === "android") {
    if (window.Android && window.Android["pwaAmpEvents"]) {
      window.Android["pwaAmpEvents"](JSON.stringify(actionData));
    }
  } else {
    return;
  }
};

const checkQrOrderTimerExpiry = () => {
  const expiryTime = Number(sessionStorage.getItem("qrOrderExpiry")) || 0;
  const isQrOrderFlow = LocalStorageFunc.getIsQrOrder();
  if (
    isQrOrderFlow &&
    (!Number.isFinite(expiryTime) || Date.now() >= expiryTime)
  ) {
    LocalStorageFunc.setDeliveryType(ORDER_TYPE.DELIVERY);
    LocalStorageFunc.clearStoreData();
    store.commit(keyMapsMutation.UPDATE_QR_ORDER, false);
    store.commit(keyMapsMutation.RESET_LOCATIONTATE, false);
    store.commit(keyMapsMutation.LOAD_CURRENT_ORDER_TYPE, {});
    sessionStorage.removeItem("qrOrderExpiry");
    sessionStorage.setItem("qrOrder", "false");
    store.commit(keyMapsMutation.SET_CART_DIRECT, []);
    store.commit(keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN, false);
  }
};

export default {
  pizzaCounter,
  randomnumber,
  tryJsonParse,
  calculateIsTrueLocationDetectedFromLocationSource,
  takeawayDineinFolder,
  redirectUrlForNonDeliveryOrderType,
  deliveryFolder,
  textLowerAndTrimSpace,
  getPwaV2CurrentCustomisation,
  keybasedProductItem,
  getCategoryIdBasedMenuCodesFromSequencing,
  sequencedProductItems,
  checkIfOrderTypeNonDelivery,
  getCurrentToppingsTotalPrice,
  sendToLoginScreen,
  getAppDownloadLink,
  getCurrentStoreFolder,
  scrollUptoTo,
  deepCopyArry,
  sortQniqueArry,
  getToppingPriceForSize,
  getMilestoneStage,
  getWidgetWidthHeight,
  toppingsNameByToppingId,
  amplitudeEventObj,
  currentCrustName,
  currentSizeName,
  returnsGetItemWQuantity,
  jsonParser,
  getSessionStorageValue,
  replaceToppingText,
  defaultToppingsCustomAtrrArry,
  getAddressAlias,
  findOrdinalsSufixInDate,
  getNotAvailablePizzaInStore,
  getDomain,
  setCookie,
  getCookie,
  deleteCookie,
  addKeyToCartWhenReloadsData,
  getUrlQueryString,
  getQueryFromUrl,
  checkWindowLocationIncludes,
  isStoreUrlCacheEligible,
  getSitePropsVersion,
  prepareImgPath,
  getProductImages,
  checkNextgenVariant,
  isNoRedirectTrue,
  getEcomCategoryFromCode,
  checkIfIsMiniApp,
  checkIfIsGpay,
  checkIfIsPAYTM,
  getMiniAppStorageVal,
  scrollUptoMenuTop,
  redirectToLoginScreen,
  storeRegex,
  scrollUptoMenuTop,
  checkIfMiniAppSwitch,
  addUpdateParam,
  setSessionStorageValue,
  addMissingKeyAccToLoadDataAndProductItems,
  scrollToFromSessionKey,
  startupAppiCalls,
  getLinkRewriteFromSiteprops,
  initializeUtmAttributes,
  getProductVideo,
  getNoRedirectFromWindow,
  replaceSubstringWithArrayValues,
  getProcessedString,
  isKeyAvailAndObjNotEmpty,
  isPageReloaded,
  checkIfDefaultStoreId,
  getProductHashcode,
  shouldRedirectToCategory,
  getMenuCategory,
  isSeparateMenuVariant,
  promoAppliedFromCartPage,
  isEdvItem,
  encryptData,
  decryptData,
  timeoutPromise,
  isEdvPage,
  getUTCMilliseconds,
  getEdvPageUrl,
  getQueryFromUrlWithSpace,
  getNextGenTntUrl,
  getNextGenCartUrl,
  sendToNextGenCart,
  isCartQtyLimitError,
  showCartQtyLimitError,
  translateNewResponseToOldResponseCoupon,
  getNxgMiddlewareHeaders,
  normalizeArray,
  areArraysEqual,
  fireHomeTrackAmplitudeEvent,
  validateXlabsTimeDiff,
  fireSgOneClickAmplitudeEvent,
  isCorporateOrderingDisabled,
  showCorporateDisabledError,
  convertValidItemsToFinalData,
  isMenuPage,
  getOrderedMenuCategories,
  isLoyaltyPage,
  hydrateCartItemsWithProductData,
  redirectToTncScreen,
  sortLoyaltyItems,
  sendToLoyaltyScreen,
  sendToNxgWalletScreen,
  sendToMenuScreen,
  redirectToHomeOrRedirectUrl,
  isRelayPage,
  redirectionMultiAsset,
  prepareProductDefinitionObjForApp,
  loyaltyProductMenuType,
  sendEventToApp,
  getSkuId,
  checkQrOrderTimerExpiry,
};
